//Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --Start
import { memo, useCallback, useMemo, useRef } from 'react';
import { BzInputText, BzMasterAgGrid } from '../../components';
import { useLocation } from 'react-router';
import { SCREENERS_HOLDINGS_GRID_REF, displayZeroStateForGrid, setScreenersGoldingsGrifRef } from '../../utils/global_functions';
import { Col, Container, Row } from 'react-bootstrap';
import dayjs from 'dayjs';
import { LOCATIONS, strSearch } from '../../utils/global_variables';
import { setStrSearch } from '../../utils/global_variables';

const ScreenersHoldingsGrid = ({ trayExpanded, mergerAndAcqData, bulkData, blockData, strSeletedCategory, objselectedScreener, ...props }) => {
    const location = useLocation();
    setScreenersGoldingsGrifRef(useRef());

    //k Hari  - 23-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --start
    const onChangeGridHeaderSearch = useCallback((e) => {
        setStrSearch(e?.target?.value);
        SCREENERS_HOLDINGS_GRID_REF?.current?.api?.onFilterChanged();
        // Vinit R - 04-07-2024 -- Add zero state for AG grid -- Start
        displayZeroStateForGrid(SCREENERS_HOLDINGS_GRID_REF);
        // Vinit R - 04-07-2024 -- Add zero state for AG grid -- End
    }, []);

    const GridHeaderSearch = ({ className, ...props }) => {
        return <div className='ag-react-container'>
            <div className='d-flex flex-row justify-content-start align-items-center'>
                <div className='icon-14 icon-search icon-grey'></div>
                <BzInputText size="sm" id='watchlist_header_search' onInput={onChangeGridHeaderSearch} className='p-l-30 scripname-searchtext' type='search' placeholder='Search scrips' autoComplete='off' />
            </div>
        </div>
    };

    const sortingComparator = useCallback((number1, number2) => {
        number1 = Number(number1);
        number2 = Number(number2);
        if (number1 === null) {
            return 0.00;
        }
        if (number2 === null) {
            return 0.00;
        }
        return number1 - number2;
    }, []);
    //k Hari  - 23-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners -- end

    //Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --Start
    let bulkorBLockGrid = useMemo(() => [
        {
            field: 'Date',
            headerName: 'DATE',
            minWidth: 100,
            filter: 'agTextColumnFilter',
            cellRenderer: params => (<span className='font-regular font-size3 color-subtext'>{dayjs(params?.value)?.format('DD MMM \'YY')}</span>)  //k Hari  - 23-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners - changed date format
            // comparator: sortingComparator 
        },
        {
            field: 'ScripName',
            headerName: 'SCRIP NAME',
            minWidth: 100,
            filter: 'agTextColumnFilter',
            headerComponent: GridHeaderSearch, cellRenderer: params => (<span className='font-medium  font-size3 text-uppercase text-truncate'>{params?.value}</span>)
            // comparator: sortingComparator 
        },
        {
            field: 'BuySell',
            headerName: 'TYPE',
            minWidth: 100,
            filter: 'agTextColumnFilter',
            cellRenderer: params => {
                if (params?.value === 'B') {
                    return <span className='font-regular font-size2 color-text color-positive'>BUY</span>;
                } else {
                    return <span className='font-regular font-size2 color-text color-negative'>SELL</span>;
                }
            }
            // comparator: sortingComparator 
        },
        {
            field: 'QuantityShares',
            headerName: 'QTY',
            minWidth: 100,
            filter: 'agTextColumnFilter',
            comparator: sortingComparator,
            cellRenderer: params => (
                <div className='font-regular font-size2 color-text'>{params?.value}</div>
            )
            // comparator: sortingComparator 
        },
        {
            field: 'AveragePrice',
            headerName: 'PRICE',
            minWidth: 100,
            filter: 'agTextColumnFilter',
            comparator: sortingComparator,
            cellRenderer: params => (
                <div className='font-regular font-size2 color-text'>{params?.value}</div>
            )
            // comparator: sortingComparator 
        },
        {
            field: 'ClientName',
            headerName: 'TRANSACTED BY',
            minWidth: 100,
            filter: 'agTextColumnFilter',
            cellRenderer: params => (
                <div className=' font-regular font-size2 color-text text-truncate'>{params?.value}</div>
            )
            // comparator: sortingComparator 
        },
    ], []);
    //Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --End

    //Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --Start
    let mergerAndAq = useMemo(() => [
        {
            field: 'Flag',
            headerName: 'TYPE',
            minWidth: 100,
            filter: 'agTextColumnFilter',
            cellRenderer: params => {
                if (params?.value === 'Merger') {
                    return <div className='font-regular font-size2 color-text color-demerger'>{params?.value}</div>;
                } else {
                    return <div className='font-regular font-size2 color-text color-merger'>{params?.value}</div>;
                }
            }

            // comparator: sortingComparator 
        },
        {
            field: 'MergedFrom_Symbol',
            headerName: 'FROM COMPANY',
            minWidth: 100,
            filter: 'agTextColumnFilter',
            cellRenderer: params => (
                <div className='font-medium font-size2 color-text text-uppercase text-truncate'>{params?.value}</div>
            )
            // comparator: sortingComparator 
        },
        {
            field: 'MergedInto_CompanyName',
            headerName: 'TO COMPANY',
            minWidth: 100,
            filter: 'agTextColumnFilter',
            cellRenderer: params => (
                <div className='font-medium font-size2 color-text text-uppercase text-truncate'>{params?.value}</div>
            )
            // comparator: sortingComparator 
        },
        {
            field: 'XDate',
            headerName: 'ISSUE DATE',
            minWidth: 100,
            filter: 'agTextColumnFilter',
            cellRenderer: params => (
                <div className='font-regular font-size3 color-text'>{dayjs(params?.value)?.format('DDMMM\'YY').toUpperCase()}</div> //k Hari  - 23-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners - changed date format
            )
            // comparator: sortingComparator 
        },

        {
            field: 'RecordDate',
            headerName: 'RECORD DATE',
            minWidth: 100,
            filter: 'agTextColumnFilter',
            cellRenderer: params => (
                <div className='font-regular font-size3 color-text'>{dayjs(params?.value)?.format('DDMMM\'YY').toUpperCase()}</div> //k Hari  - 23-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners - changed date format
            )
            // comparator: sortingComparator 
        },
        {
            field: 'MergerRatio',
            headerName: 'RATIO',
            minWidth: 100,
            filter: 'agTextColumnFilter',
            cellRenderer: params => (
                <div className='font-medium font-size2 color-text'>{params?.value}</div>
            )
            // comparator: sortingComparator 
        },

    ], []);
    //Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --End

    //Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --Start
    const arrColumnDefs = useMemo(() => {
        if (strSeletedCategory === 'Market' && ['Bulk Deals', 'Block Deals']?.includes(objselectedScreener?.GroupName)) {
            return bulkorBLockGrid;
        } else if (strSeletedCategory === 'Market' && objselectedScreener?.GroupName === 'Merger & Acquisition') {
            return mergerAndAq;
        } else {
            return [];
        }
    }, [bulkorBLockGrid, mergerAndAq, objselectedScreener, strSeletedCategory]);
    //Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --End

    const arrScreenersGridData = useMemo(() => {
        if (strSeletedCategory === 'Market' && objselectedScreener?.GroupName === 'Merger & Acquisition') {
            return mergerAndAcqData;
        } else if (strSeletedCategory === 'Market' && objselectedScreener?.GroupName === 'Bulk Deals') {
            return bulkData;
        } else if (strSeletedCategory === 'Market' && objselectedScreener?.GroupName === 'Block Deals') {
            return blockData;
        } else {
            return [];
        }
    }, [strSeletedCategory, objselectedScreener, mergerAndAcqData, bulkData, blockData,]);

    //k Hari  - 23-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --start
    const isExternalFilterPresent = useCallback(() => {
        return strSearch !== null;
    }, []);

    const doesExternalFilterPass = useCallback(
        (node) => {
            return node?.data?.ScripName?.toUpperCase()?.includes(strSearch?.toUpperCase());
        }, [strSearch]
    );
    //k Hari  - 23-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --end
    

    return (
        <>
            <Container fluid className='p-0'>
                <Row className='g-0'>
                    <Col>
                        <BzMasterAgGrid  isExternalFilterPresent={isExternalFilterPresent} doesExternalFilterPass={doesExternalFilterPass} ref={SCREENERS_HOLDINGS_GRID_REF} arrRowData={arrScreenersGridData} arrColumnData={arrColumnDefs} className={(location?.pathname === LOCATIONS.DASHBOARD) ? `ag-theme-alpine screenersholding-expand-sidebar-wrapper` : trayExpanded ? `ag-theme-alpine screenersholding-expand-sidebar-wrapper` : `ag-theme-alpine  screenersholding-ag-grid-sidebar-wrapper`} />
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default memo(ScreenersHoldingsGrid);
//Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --End